import { Route, Navigate } from 'react-router-dom';

// 로그인/회원가입
import Login from 'pages/login';
import FindAccount from 'pages/findAccount';
import Membership from 'pages/membership';
import MembershipComplete from 'pages/membership/MembershipComplete';
import Main from 'pages/main';

// 사업 현황 관리
import LocalStatus from 'pages/localStatus';
import LocalStatusWrite from 'pages/localStatus/Write';
import LocalStatusDetail from 'pages/localStatus/Detail';

// 실태 조사 관리
import RealSurvey from 'pages/realSurvey';
import RealSurveyWrite from 'pages/realSurvey/Write';
import RealSurveyDetail from 'pages/realSurvey/Detail';

// 프로젝트 양식 관리
import Agenda from 'pages/agenda';
import AgendaWrite from 'pages/agenda/Write';
import AgendaDetail from 'pages/agenda/Detail';
import Template from 'pages/template';

// 지역 이슈 관리
import ProjectRequest from 'pages/projectRequest';
import ProjectRequestWrite from 'pages/projectRequest/Write';
import ProjectRequestDetail from 'pages/projectRequest/Detail';

// 지역 이슈 파인더
import LocalIssueFinder from 'pages/localIssueFinder';
import LocalIssueFinderWrite from 'pages/localIssueFinder/Write';
import LocalIssueFinderDetail from 'pages/localIssueFinder/Detail';

// HWPX 양식 관리
import FormTemplateList from 'pages/formTemplate';
import FormTemplateWrite from 'pages/formTemplate/Write';
import FormTemplateDetail from 'pages/formTemplate/Detail';
import Project from 'pages/project';
import AgendaRequest from 'pages/agendaRequest';
import AgendaRequestWrite from 'pages/agendaRequest/Write';
import AgendaRequestDetail from 'pages/agendaRequest/Detail';

// 회원 관리
import Account from 'pages/account';

// 게시판 관리
// 홍보자료(기존: 성과보고회 우수영상관)
import Promotion from 'pages/promotion';
import PromotionWrite from 'pages/promotion/Write';
import PromotionDetail from 'pages/promotion/Detail';
// 부처소식
import Department from 'pages/department';
import DepartmentWrite from 'pages/department/Write';
import DepartmentDetail from 'pages/department/Detail';
// 주요결과(기존: 성과보고회 우수영상관, 성과보고회 공지사항 데이터 관리)
import Result from 'pages/result'; // 주요결과
import ResultWrite from 'pages/result/Write'; // 주요결과 등록
import ResultDetail from 'pages/result/Detail'; // 주요결과 상세
// 성과자료실
import Performance from 'pages/performance'; // 성과자료실
import PerformanceWrite from 'pages/performance/Write'; // 성과자료실 등록
import PerformanceDetail from 'pages/performance/Detail'; // 성과자료실 상세
// 공지사항
import Notice from 'pages/notice';
import NoticeWrite from 'pages/notice/Write';
import NoticeDetail from 'pages/notice/Detail';
// 사업공고
import Announcement from 'pages/announcement';
// 보도자료
import PressRelease from 'pages/pressRelease';

// 문의하기
import Question from 'pages/question';
import QuestionDetail from 'pages/question/Detail';
import QuestionWrite from 'pages/question/Write';

// 투표 관리
import Vote from 'pages/vote';
import VoteResult from 'pages/vote/result';

import { selectType } from 'store/slices/users';
import { useSelector } from 'react-redux';

// route 권한을 roles로 변경함 roles 배열에 들어있는 userType만 접근 가능함
const RouteList = [
  { path: '/login', element: <Login />, roles: [] },
  { path: '/membership', element: <Membership />, roles: [] },
  { path: '/membershipComplete', element: <MembershipComplete />, roles: [] },
  { path: '/findPassword', element: <FindAccount />, roles: [] },
  { path: '/findId', element: <FindAccount />, roles: [] },

  { path: '/', element: <Main />, roles: ['user', 'admin', 'master'] },
  // 프로젝트 양식 관리 > 아젠다 관리
  { path: '/agenda', element: <Agenda />, roles: ['admin', 'master'] },
  { path: '/agenda/write/:id?', element: <AgendaWrite />, roles: ['admin', 'master'] },
  { path: '/agenda/detail/:id', element: <AgendaDetail />, roles: ['admin', 'master'] },
  // 프로젝트 양식 관리 > 템플릿 관리
  { path: '/template', element: <Template />, roles: ['admin', 'master'] },
  // 지역 이슈 관리 > 신규 등록 목록
  { path: '/projectRequest', element: <ProjectRequest />, roles: ['user', 'admin', 'master'] },
  { path: '/projectRequest/write/:id?', element: <ProjectRequestWrite />, roles: ['user', 'admin', 'master'] },
  { path: '/projectRequest/detail/:id', element: <ProjectRequestDetail />, roles: ['user', 'admin', 'master'] },
  // 지역 이슈 관리 > 프로젝트 목록
  { path: '/project', element: <Project />, roles: ['admin', 'master'] },
  { path: '/project/detail/:id', element: <ProjectRequestDetail />, roles: ['admin', 'master'] },
  // 지역 이슈 관리 > 아젠다 요청 목록
  { path: '/agendaRequest', element: <AgendaRequest />, roles: ['user', 'admin', 'master'] },
  { path: '/agendaRequest/write/:id?', element: <AgendaRequestWrite />, roles: ['user', 'admin', 'master'] },
  { path: '/agendaRequest/detail/:id', element: <AgendaRequestDetail />, roles: ['user', 'admin', 'master'] },
  // 지역 이슈 파인더
  { path: '/localIssueFinder', element: <LocalIssueFinder />, roles: ['user', 'admin', 'master'] },
  { path: '/localIssueFinder/write/:id?', element: <LocalIssueFinderWrite />, roles: ['user', 'admin', 'master'] },
  { path: '/localIssueFinder/detail/:id', element: <LocalIssueFinderDetail />, roles: ['user', 'admin', 'master'] },
  // HWPX 양식 관리
  { path: '/formTemplate', element: <FormTemplateList />, roles: ['admin', 'master'] },
  { path: '/formTemplate/write/:formId?', element: <FormTemplateWrite />, roles: ['admin', 'master'] },
  { path: '/formTemplate/detail/:formId', element: <FormTemplateDetail />, roles: ['admin', 'master'] },
  // 회원 관리
  { path: '/account', element: <Account />, roles: ['admin', 'master'] },

  // 사업 현황 관리
  { path: '/localStatus', element: <LocalStatus />, roles: ['master'] },
  { path: '/localStatus/write/:id?', element: <LocalStatusWrite />, roles: ['master'] },
  { path: '/localStatus/detail/:id', element: <LocalStatusDetail />, roles: ['master'] },
  // 실태 조사 관리
  { path: '/realSurvey', element: <RealSurvey />, roles: ['master'] },
  { path: '/realSurvey/write/:year/:region?', element: <RealSurveyWrite />, roles: ['master'] },
  { path: '/realSurvey/detail/:year/:region', element: <RealSurveyDetail />, roles: ['master'] },
  // 게시판 관리 > 홍보자료 관리(기존: 성과보고회 우수영상관)
  { path: '/promotion', element: <Promotion />, roles: ['master', 'admin'] },
  { path: '/promotion/write/:id?', element: <PromotionWrite />, roles: ['master', 'admin'] },
  { path: '/promotion/detail/:id', element: <PromotionDetail />, roles: ['master', 'admin'] },
  // 게시판 관리 > 부처소식 관리
  { path: '/department', element: <Department />, roles: ['master', 'admin'] },
  { path: '/department/write/:id?', element: <DepartmentWrite />, roles: ['master', 'admin'] },
  { path: '/department/detail/:id', element: <DepartmentDetail />, roles: ['master', 'admin'] },
  // 게시판 관리 > 주요결과 관리(기존: 성과보고회 우수영상관, 성과보고회 공지사항 데이터 관리)
  { path: '/result', element: <Result />, roles: ['master', 'admin'] },
  { path: '/result/write/:id?', element: <ResultWrite />, roles: ['master', 'admin'] },
  { path: '/result/detail/:id', element: <ResultDetail />, roles: ['master', 'admin'] },
  // 게시판 관리 > 성과자료실 관리
  { path: '/performance', element: <Performance />, roles: ['master', 'admin'] },
  { path: '/performance/write/:id?', element: <PerformanceWrite />, roles: ['master', 'admin'] },
  { path: '/performance/detail/:id', element: <PerformanceDetail />, roles: ['master', 'admin'] },
  // 게시판 관리 > 공지사항 관리
  { path: '/notice', element: <Notice />, roles: ['master', 'admin'] },
  { path: '/notice/write/:id?', element: <NoticeWrite />, roles: ['master', 'admin'] },
  { path: '/notice/detail/:id?', element: <NoticeDetail />, roles: ['master', 'admin'] },
  // 게시판 관리 > 사업공고 관리
  { path: '/announcement', element: <Announcement />, roles: ['master', 'admin'] },
  // 게시판 관리 > 보도자료 관리
  { path: '/pressRelease', element: <PressRelease />, roles: ['master', 'admin'] },
  //게시판 관리 > 문의하기
  { path: '/question', element: <Question />, roles: ['master', 'admin', 'user'] },
  { path: '/question/detail/:id?', element: <QuestionDetail />, roles: ['master', 'admin', 'user'] },
  { path: '/question/write', element: <QuestionWrite />, roles: ['user'] },
  { path: '/question/write/:id', element: <QuestionWrite />, roles: ['master', 'admin', 'user'] },
  // 투표 관리
  { path: '/vote', element: <Vote />, roles: ['user', 'admin', 'master'] },
  { path: '/vote/result', element: <VoteResult />, roles: ['user', 'admin', 'master'] }
];

function RedirectRoute({ isLogin, element }) {
  return isLogin ? <Navigate to="/" replace /> : element;
}

function ProtectedRoute({ element, isLogin, roles }) {
  const userType = useSelector(selectType);

  switch (userType) {
    case 'master':
      return isLogin ? element : <Navigate to="/login" replace />;
    case 'admin':
      if (roles?.includes('admin')) {
        return isLogin ? element : <Navigate to="/login" replace />;
      }
      return isLogin ? <Navigate to="/" replace /> : <Navigate to="/login" replace />;

    case 'user':
      if (roles?.includes('user')) {
        return isLogin ? element : <Navigate to="/login" replace />;
      }
      return isLogin ? <Navigate to="/" replace /> : <Navigate to="/login" replace />;

    default:
      return <Navigate to="/login" replace />;
  }
}

export const generateRoutes = isLogin => {
  return (
    <>
      {RouteList.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          element={
            route.roles?.length === 0 ? (
              <RedirectRoute element={route.element} isLogin={isLogin} />
            ) : (
              <ProtectedRoute element={route.element} isLogin={isLogin} roles={route.roles} />
            )
          }
        />
      ))}
      <Route path="*" element={<Navigate to="/" replace />}></Route>
    </>
  );
};

export default RouteList;
